<template>
  <div class="search flex flex-row">
    <el-input
      :placeholder="placeholder"
      v-model.trim="searchValue"
      @keypress.native.enter="search"
      class="search-input"
      clearable
      maxlength="30"
    >
      <el-button slot="append" class="search-btn" @click="search"
        >查询</el-button
      >
    </el-input>
    <div class="search-result" v-if="showNum">
      共
      <span>{{ num }}</span>
      个结果
    </div>
  </div>
</template>
<script>
export default {
  name: "searchBar",
  props: {
    num: {
      type: Number,
      default: 0,
    },
    value: {
      type: String,
      default: "",
    },
    showNum: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "请输入关键字进行检索",
    },
  },
  computed: {
    // 读取和设置
    searchValue: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    search() {
      this.$emit("btnClick");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.search {
  &-input {
    width: 400px;
    margin-right: 15px;
  }
  ::v-deep .el-input-group--append {
    .el-input__inner {
      border: 0;
      border-radius: 30px 0 0 30px;
      border: 1px solid $theme-color;
      border-right: 0;
      height: 46px;
      &:focus {
        border: 1px solid #2878ff;
        border-right: 0;
      }
    }
  }
  ::v-deep .el-input-group__append {
    border: 0;
    width: 55px;
    background: linear-gradient(to bottom, #1082bd, #005ca7);
    color: #fff;
    border-radius: 0 30px 30px 0;
    &:hover {
      background: linear-gradient(to bottom, #1070bd, #005ca7);
    }
  }
  &-result {
    line-height: 46px;
    > span {
      color: $theme-color;
      font-weight: bold;
    }
  }
}
</style>
